import React, { useEffect, useState } from 'react'
import DealService from '../Services/DealService';
import Modal from "react-modal";
import html2pdf from 'html2pdf.js';
import { getIcons } from '../Constant/Constant';



const ReportPDFModal = ({ isOpenModal,setIsOpenModal, dealID, excessAmount, pendingAmount }) => {
 const images = getIcons()
    const [propertyData, setPropertyData] = useState(null);
    useEffect(() => {
        if (isOpenModal && dealID) {
          const body = {
            docId : dealID,
          }
          DealService.getCostsheetData(body)
            .then((response) => {
              setPropertyData(response.data);
            })
            .catch((error) => {
              console.error("Error fetching property data:", error);
            });
        }
      }, [isOpenModal, dealID]);

    const generatePDF = () => {
        const element = document.getElementById("pdf-content");
      
        // Temporarily show the hidden content
        element.classList.remove("hidden");
        const today = new Date();
        const formattedDate = `${today
            .getDate()
            .toString()
            .padStart(2, '0')}-${(today.getMonth() + 1)
            .toString()
            .padStart(2, '0')}-${today.getFullYear()}`;
        const options = {
          filename: `${formattedDate} ${propertyData?.propertyName} Unit No: ${propertyData?.unitNo} Report.pdf`,
          image: { type: 'png', quality: 1.0 },
          html2canvas: { scale: 2, useCORS: true },
          jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' }
        };
      
        // Generate PDF
        html2pdf().from(element).set(options).save().then(() => {
          // Re-hide the content after generating the PDF
          element.classList.add("hidden");
        });
      };

      const handleCloseModal = () => {
        setIsOpenModal(false);
      };

      const customStyles = {
        content: {
          top: "50%",
          left: "50%",
          right: "auto",
          bottom: "auto",
          marginRight: "-50%",
          transform: "translate(-50%, -50%)",
          width: "60%",
          padding: "20px",
          position: "relative",
          height: "60%",
        },
        overlay: {
          backgroundColor: "rgba(0, 0, 0, 0.75)",
        },
      };
  return (
    <div>
      <Modal
        isOpen={isOpenModal}
        onRequestClose={handleCloseModal}
        contentLabel="Create Team"
        style={customStyles}
      >
        <button
          onClick={handleCloseModal}
          className="absolute top-2 right-2 text-2xl text-gray-700"
        >
          &times;
        </button>

        <div className="">
          <h1 className="text-center font-semibold text-xl mb-8">Cost Sheet</h1>
          <div className=" w-full ">
            <div className="mb-8 flex items-center gap-16">
              <label
                className="w-1/4 text-gray-700 text-lg font-medium"
                htmlFor="name"
              >
                Property Name
              </label>
              <input
                className={`shadow appearance-none border rounded w-2/4 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline`}
                id="name"
                type="text"
                readOnly
                value={propertyData?.propertyName|| ""}
              />
            </div>

            <div className="mb-8 flex items-center gap-16">
              <label
                className="w-1/4 text-gray-700 text-lg font-medium"
                htmlFor="name"
              >
              Unit No
              </label>
              <input
                className={`shadow appearance-none border rounded w-2/4 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline`}
                id="name"
                type="text"
                readOnly
                value={propertyData?.unitNo || ""}
              />
            </div>
            <div className="mb-8 flex items-center gap-16">
              <label
                className="w-1/4 text-gray-700 text-lg font-medium"
                htmlFor="name"
              >
                Total sq.ft
              </label>
              <input
                className={`shadow appearance-none border rounded w-2/4 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline`}
                id="name"
                type="text"
                readOnly
                value={propertyData?.totalSqft || ""}
              />
            </div>

            <div className="mb-8 flex items-center gap-16">
              <label
                className="w-1/4 text-gray-700 text-lg font-medium"
                htmlFor="name"
              >
                Rate/sq.ft
              </label>
              <input
                className={`shadow appearance-none border rounded w-2/4 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline`}
                id="name"
                type="text"
                readOnly
                value={propertyData?.ratePersqft || ""}
              />
            </div>

            <div className="mb-8 flex items-center gap-16">
              <label
                className="w-1/4 text-gray-700 text-lg font-medium"
                htmlFor="name"
              >
                Total Cost
              </label>
              <input
                className={`shadow appearance-none border rounded w-2/4 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline`}
                id="name"
                type="text"
                readOnly
                value={propertyData?.totalCost || ""}
              />
            </div>

            <div className="mb-8 flex items-center gap-16">
              <label
                className="w-1/4 text-gray-700 text-lg font-medium"
                htmlFor="name"
              >
                Already paid
              </label>

              <input
                className={`shadow appearance-none border rounded w-2/4 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline`}
                id="name"
                type="text"
                readOnly
                value ={propertyData?.alreadyPaid || 0}
              />
            </div>


            <h1 className="text-center mb-8 underline">LOAN/DD</h1>
            <div className="mb-8 flex items-center gap-16">
              <label
                className="w-1/4 text-gray-700 text-lg font-medium"
                htmlFor="name"
              >
                Guideline value( )
              </label>
              <input
                className={`shadow appearance-none border rounded w-2/4 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline`}
                id="name"
                type="text"
                readOnly
                value={propertyData?.guidelineValue }

              />
            </div>

            <div className="mb-8 flex items-center gap-16">
              <label
                className="w-1/4 text-gray-700 text-lg font-medium"
                htmlFor="name"
              >
                Development value( )
              </label>
              <input
                className={`shadow appearance-none border rounded w-2/4 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline`}
                id="name"
                type="text"
                readOnly
                // value={name}
              />
            </div>

            <div className="mb-8 flex items-center gap-16">
              <label
                className="w-1/4 text-gray-700 text-lg font-medium"
                htmlFor="name"
              >
                Loan amount
              </label>
              <input
                className={`shadow appearance-none border rounded w-2/4 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline`}
                id="name"
                type="text"
                readOnly
                // value={name}
              />
            </div>

            <div className="mb-8 flex items-center gap-16">
              <label
                className="w-1/4 text-gray-700 text-lg font-medium"
                htmlFor="name"
              >
                Sanction loan amount(80%)
              </label>
              <input
                className={`shadow appearance-none border rounded w-2/4 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline`}
                id="name"
                type="text"
                readOnly
                // value={name}
              />
            </div>

            <h1 className="text-center mb-8 underline">Remaining OCR(20%)</h1>


            <div className="mb-8 flex items-center gap-16">
              <label
                className="w-1/4 text-gray-700 text-lg font-medium"
                htmlFor="name"
              >
                Guideline value OCR( /-)
              </label>
              <input
                className={`shadow appearance-none border rounded w-2/4 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline`}
                id="name"
                type="text"
                readOnly
                value={propertyData?.ocrGuidelineValue}

                
              />
            </div>

            <div className="mb-8 flex items-center gap-16">
              <label
                className="w-1/4 text-gray-700 text-lg font-medium"
                htmlFor="name"
              >
                Development value( /-)
              </label>
              <input
                className={`shadow appearance-none border rounded w-2/4 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline`}
                id="name"
                type="text"
                readOnly
                // value={name}
              />
            </div>

            <div className="mb-8 flex items-center gap-16">
              <label
                className="w-1/4 text-gray-700 text-lg font-medium"
                htmlFor="name"
              >
                Remaining balance amount
              </label>
              <input
                className={`shadow appearance-none border rounded w-2/4 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline`}
                id="name"
                type="text"
                readOnly
                value={pendingAmount}
              />
            </div>

            <h1 className="text-center mb-8 underline">REGISTRATION</h1>

            <div className="mb-8 flex items-center gap-16">
              <label
                className="w-1/4 text-gray-700 text-lg font-medium"
                htmlFor="name"
              >
                Registration cost %(online)
              </label>
              <input
                className={`shadow appearance-none border rounded w-2/4 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline`}
                id="name"
                type="text"
                readOnly
                value={propertyData?.registrationCharge}
              />
            </div>

            <div className="mb-8 flex items-center gap-16">
              <label
                className="w-1/4 text-gray-700 text-lg font-medium"
                htmlFor="name"
              >
                MOD (0.5%) (online)
              </label>
              <input
                className={`shadow appearance-none border rounded w-2/4 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline`}
                id="name"
                type="text"
                readOnly
                value={propertyData?.modHalfPercentage}
              />
            </div>

            <div className="mb-8 flex items-center gap-16">
              <label
                className="w-1/4 text-gray-700 text-lg font-medium"
                htmlFor="name"
              >
                MOD registration(online)
              </label>
              <input
                className={`shadow appearance-none border rounded w-2/4 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline`}
                id="name"
                type="text"
                readOnly
                value={propertyData?.modRegistration }
              />
            </div>

            <div className="mb-8 flex items-center gap-16">
              <label
                className="w-1/4 text-gray-700 text-lg font-medium"
                htmlFor="name"
              >
                Cd, subdivision cost, computer fees (online)
              </label>
              <input
                className={`shadow appearance-none border rounded w-2/4 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline`}
                id="name"
                type="text"
                readOnly
                value={propertyData?.subDivFee}
              />
            </div>

            <div className="mb-8 flex items-center gap-16">
              <label
                className="w-1/4 text-gray-700 text-lg font-medium"
                htmlFor="name"
              >
                Document fees (cash)
              </label>
              <input
                className={`shadow appearance-none border rounded w-2/4 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline`}
                id="name"
                type="text"
                readOnly
                value={propertyData?.documentFee}
              />
            </div>

            <div className="mb-8 flex items-center gap-16">
              <label
                className="w-1/4 text-gray-700 text-lg font-medium"
                htmlFor="name"
              >
                TOTAL COST OF REGISTRATION
              </label>
              <input
                className={`shadow appearance-none border rounded w-2/4 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline`}
                id="name"
                type="text"
                readOnly
                value={propertyData?.totalRegistrationCost}
              />
            </div>

            <div className="mb-8 flex items-center gap-16">
              <label
                className="w-1/4 text-gray-700 text-lg font-medium"
                htmlFor="name"
              >
                Excess
              </label>
              <input
                className={`shadow appearance-none border rounded w-2/4 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline`}
                id="name"
                type="text"
                readOnly
                value={propertyData?.excessAmount}
              />
            </div>
          </div>
          <button
        onClick={generatePDF}
        className="mt-4 bg-customGreen  text-white py-2 px-4 rounded"
      >
        Download as PDF
      </button>

        </div>
      </Modal>



<div id="pdf-content" className=' hidden'>
    <div>
        <img src={images.registrationReportHeader} alt="" />
    </div>
<div    className='mx-20 '>

<table className=''>
<tbody>
    <tr >
        <td className='  pt-[6px]' >
        Property Name 
        </td>
        <td className='w-54   pt-[6px]'>:</td>
        



        
        <td className='  pt-[6px] pl-5 '>{propertyData?.propertyName || " "}</td>
    </tr>
    <tr >
        <td className='  pt-[6px]' >
        Plot No 
        </td>
        <td className='w-54   pt-[6px]'>:</td>
        



        
        <td className='  pt-[6px] pl-5 '>{propertyData?.unitNo|| " "}</td>
    </tr>
    <tr>
        <td className='  pt-[6px]'>
        Total sq.ft         </td>
        <td className='  pt-[6px]'>:</td>
        
        <td className='  pt-[6px] pl-5 '>{propertyData?.totalSqft || ""} sqft </td>
    </tr>
    <tr>
        <td className='  pt-[6px]'>
        Rate/sq.ft        </td>
        <td className='  pt-[6px]'>:</td>
        
        <td className='  pt-[6px] pl-5 '>{propertyData?.ratePersqft || ""}</td>
    </tr>
    <tr>
        <td className='  pt-[6px]'>
Total Cost        </td>
        <td className='  pt-[6px]'>:</td>
        
        <td className='  pt-[6px] pl-5 '>{propertyData?.totalCost}</td>
    </tr>
    <tr>
        <td className='  pt-[6px]'>
        Already Paid        </td>
        <td className='  pt-[6px]'>:</td>
        
        <td className='  pt-[6px] pl-5 '>
        {
        propertyData?.alreadyPaid 

        }
        </td>
    </tr>
    <tr>
        <td className="underline font-medium   pt-[6px]">LOAN/DD
        </td>
        <td className='  pt-[6px]'></td>
        
    </tr>
    <tr>
        <td className='  pt-[6px]'>
        Guideline Value        </td>
        <td className='  pt-[6px]'>:</td>
        
        <td className='  pt-[6px] pl-5 '>{propertyData?.guidelineValue}</td>
    </tr>
    <tr>
        <td className='  pt-[6px]'>
        Development Value        </td>
        <td className='  pt-[6px]'>:</td>
        
        <td className='  pt-[6px] pl-5 '> </td>
    </tr>
    <tr>
        <td className='  pt-[6px]'>
        Loan Amount          </td>
        <td className='  pt-[6px]'>:</td>
        
        <td className='  pt-[6px] pl-5 '></td>
    </tr>
    <tr>
        <td className='  pt-[6px]'>
        Sanctioned Loan Amount (80%)        </td>
        <td className='  pt-[6px]'>:</td>
        
        <td className='  pt-[6px] pl-5'> </td>
    </tr>
    <tr>
    <td className="underline font-medium   pt-[6px]">
        Remaining OCR (20%)         </td>
       
    </tr>
    <tr>
        <td className='  pt-[6px]'>
        Guideline value OCR         </td>
        <td className='  pt-[6px]  '>:</td>
        
                <td className='  pt-[6px] pl-5'>
                {propertyData?.ocrGuidelineValue || ""}
                </td>
    </tr>
    <tr>
        <td className='  pt-[6px]'>
        Development value       </td>
        <td className='  pt-[6px]'>:</td>
        
        <td className='  pt-[6px] pl-5'> </td>
    </tr>
    <tr>
        <td className='  pt-[6px]'>
        Remaining balance amount         </td>
        <td className='  pt-[6px]'>:</td>
        
        <td className='  pt-[6px] pl-5'>{pendingAmount}</td>
    </tr>
   
    <tr>
        <td className="underline font-medium   pt-[6px]">REGISTRATION

        </td>
       
    </tr>

    <tr>
        <td className='  pt-[6px]'>Registration Cost  </td>
        <td className='  pt-[6px]'>
:
        </td>
        <td className='  pt-[6px] pl-5'>{propertyData?.registrationCharge}</td>
    </tr>
    <tr>
        <td className='  pt-[6px]'>MOD (0.5%)  </td>
        <td className='  pt-[6px]'>:</td>
        <td className='  pt-[6px] pl-5'>{propertyData?.modHalfPercentage}</td>
    </tr>
    <tr className='mt-5'>
        <td className='  pt-[6px]'>MOD registration(online) </td>
        <td className='  pt-[6px]'>:</td>
        <td className='  pt-[6px] pl-5'>{propertyData?.modRegistration}</td>
    </tr>
    <tr>
        <td className='  pt-[6px]'>
        Cd, subdivision cost, computer fees (online) 
        </td>
        <td className='  pt-[6px]'>:</td>
        <td className='  pt-[6px] pl-5'>{propertyData?.subDivFee || ""}</td>
    </tr>
    <tr>
        <td className='  pt-[6px]'>Document Fees  </td>
        <td className='  pt-[6px]'>:</td>
        <td className='  pt-[6px] pl-5'>{propertyData?.documentFee || ""}</td>
    </tr>
    <tr>
        <td className='  pt-[6px]'>Total Registration Cost</td>
        <td className='  pt-[6px]'>:</td>
        
        <td className='  pt-[6px] pl-5'>{propertyData?.totalPayable || ""}</td>
    </tr>
    <tr className=' '>
<td className='  pt-[6px]'>Excess</td>
<td className='  pt-[6px]'>:</td>
<td className='  pt-[6px] pl-5 '>{propertyData?.excessAmount}</td>
    </tr>
<tr>
    <td className=' pt-4'></td>
</tr>

</tbody>
</table>

</div>
<div className=''>
<img src={images.registrationReportFooter} alt="" />

</div>
</div>

</div>


  )
}

export default ReportPDFModal
